import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.IntegrationModule.NetSuiteCacheManagementPanel', {
    headerText: 'NetSuite Data Synchronisation Status',
    syncAll: 'Sync All',
    fieldCol: 'Field',
    lastSyncCol: 'Last Successful Sync',
    lastSyncErrorCol: 'Error on last sync',
});
